import { ColorRange } from "./ColorRange";
import { ColorizeMenuUI, ColorUIManager } from "./ui";
import { FieldContainer, StrategyContainer } from "./containers";
import { Switchboard } from "../../../events";
import { ColorBoundaryContainer } from "./containers/ColorBoundaryContainer";
import { ColorCalculator } from "./utils/ColorCalculator";
export class ColorManager {
    get ignored_colors() {
        return this.visible_buckets.filter(x => !x.visible).map(x => x.label);
    }
    get available_strategies() {
        if (this.gradient)
            return this.strategies.gradients;
        return this.strategies.categoricals;
    }
    constructor(opts) {
        this.fields = new FieldContainer([]);
        this.ui = new ColorUIManager();
        this.identifier = '';
        this.color_boundaries = new ColorBoundaryContainer();
        this.gradient = false;
        this.calculator = new ColorCalculator();
        this.visible_buckets = new ColorBoundaryContainer();
        this.receiver = Switchboard.get_receiver("COLOR");
        this.broadcaster = Switchboard.get_emitter("SELECTION");
        this.color_range = new ColorRange(opts.color_range);
        this.strategies = new StrategyContainer(opts.strategies);
        this.menu_ui = new ColorizeMenuUI().bind_to(this);
        this.receiver.on("change", (param) => {
            let name = param[1];
            switch (param[0]) {
                case "on":
                    this.visible_buckets.turn_on(name);
                    break;
                case "off":
                    this.visible_buckets.turn_off(name);
                    break;
                case "toggle":
                    this.visible_buckets.toggle(name);
                    break;
                case "invert":
                    this.visible_buckets.invert_on(name);
                    break;
            }
            this.broadcaster.emit("change", null);
        });
    }
    get strategy() {
        return this.strategies.current;
    }
    get color_map() {
        return this.calculator.get_color_map(this.gradient);
    }
    set_gradient(val) {
        this.gradient = val;
    }
    set_strategy(s_name) {
        const maybe_strategy = this.strategies.find(s_name);
        maybe_strategy.map(s => this.strategies.select_strategy(s));
    }
    populate_legend() {
        this.ui.hide_legend();
        if (this.strategy.isSomeAnd((s) => s.has_legend)) {
            this.visible_buckets = this.color_boundaries;
            this.ui.populate_legend(this.fields.selected.unwrapOr("UNDEFINED FIELD"), this.color_boundaries);
        }
    }
    update_strategy_type() {
        if (this.strategy.isNone()) {
            this.strategies.select_first(this.gradient);
            return;
        }
        this.strategy.map(s => {
            if (this.available_strategies.includes(s))
                return;
            this.strategies.select_first(this.gradient);
        });
    }
    populate_strategies() {
        this.update_strategy_type();
        this.menu_ui.update_strategies(this.available_strategies, this.strategy);
    }
    generate_gradient() {
        this.strategy.map(a => a.generate_colors(this.color_range));
    }
    preload(values, colors) {
        this.calculator.load(values, colors);
    }
    colorize(features) {
        const field = this.fields.selected.unwrapOr('');
        const colors = this.color_range.jenks;
        const values = features.map(f => f.get(field));
        this.calculator.load(values, colors);
        const color_map = this.color_map;
        this.color_boundaries = this.calculator.get_bounds();
        const colorize_feature = (f) => {
            var _a;
            let c = color_map(f.get(field));
            f.set('color', c);
            f.set('opacity', this.color_range.opacity);
            f.set('bucket', (_a = this.color_boundaries.find(b => b.color === c)) === null || _a === void 0 ? void 0 : _a.label);
        };
        features.forEach(colorize_feature);
    }
    get_fields_from_features(features) {
        const all_field_defs = features.map(p => p.getKeys());
        const max_fields = Math.max(...all_field_defs.map(d => d.length));
        return all_field_defs
            .find(d => d.length === max_fields)
            .filter(key => key !== this.identifier
            && key !== 'geometry'
            && key !== 'color'
            && key !== 'opacity'
            && key !== 'bucket'
            && key !== key.toUpperCase());
    }
    load_features(features) {
        const fields = this.get_fields_from_features(features);
        this.fields.update(fields);
        this.menu_ui.update_field_names(this.fields.iter(), this.fields.selected);
        this.update_strategy_type();
        this.menu_ui.update_strategies(this.available_strategies, this.strategy);
        this.generate_gradient();
        this.menu_ui.show();
    }
    hide() {
        this.ui.hide_legend();
        this.menu_ui.hide();
    }
}
